<template>
  <div class="invoice">
    <div class="content--main">
      <Invoice
        v-if="invoiceId && userId"
        scope="setting"
        :invoiceId="invoiceId"
      />
    </div>
  </div>
</template>

<script>
import Invoice from "@/components/invoice/Invoice";
export default {
  components: {
    Invoice
  },
  computed: {
    userId() {
      return this.$route.params.id;
    },
    invoiceId() {
      return this.$route.params.invoiceId;
    }
  }
};
</script>
<style lang="scss" scoped>
.invoice {
  padding: 0 15px;
  .content--main {
    height: calc(100vh - 181px);
    overflow-x: hidden;
    overflow-y: auto;
    padding-top: 10px;
  }
}
</style>
